import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import StyleFunctionSxDemo from './StyleFunctionSxDemo';
import ClientProvider from './client';
export default createDemo(import.meta.url, StyleFunctionSxDemo, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/getting-started/custom-components/demos/style-function-sx-demo/StyleFunctionSxDemo.tsx",
    "fileName": "StyleFunctionSxDemo.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import styled, { ThemeProvider } from 'styled-components';\nimport type { StyleFunction } from 'styled-components';\nimport { unstable_styleFunctionSx } from '@mui/system';\nimport type { SxProps } from '@mui/system';\nimport { createTheme } from '@mui/material/styles';\n\ninterface DivProps {\n  sx?: SxProps;\n}\n\nconst theme = createTheme();\n\nconst Div = styled('div')<DivProps>(\n  unstable_styleFunctionSx as StyleFunction<DivProps>,\n);\n\nexport default function StyleFunctionSxDemo() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <Div sx={{ m: 1, p: 1, border: 1 }}>Custom component with the sx prop</Div>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 23,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import styled, { ThemeProvider } from 'styled-components';\nimport type { StyleFunction } from 'styled-components';\nimport { unstable_styleFunctionSx } from '@mui/system';\nimport type { SxProps } from '@mui/system';\nimport { createTheme } from '@mui/material/styles';\n\ninterface DivProps {\n  sx?: SxProps;\n}\n\nconst theme = createTheme();\n\nconst Div = styled('div')<DivProps>(\n  unstable_styleFunctionSx as StyleFunction<DivProps>,\n);\n\nexport default function StyleFunctionSxDemo() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={theme}>\n      <Div sx={{ m: 1, p: 1, border: 1 }}>Custom component with the sx prop</Div>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "theme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Div"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "m"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "p"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "border"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Custom component with the sx prop</",
              [
                "span",
                "pl-c1 di-jsx",
                "Div"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 23,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "styled-components",
      "@mui/system",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
